import React from 'react';
import { FormattedMessage } from 'react-intl';

import Page from '../../components/common/page/Page';
import { withReport } from '../../context/';
import BasePassRequestByTagsOverview from '../../components/report/BasePassRequestByTagsOverview';

const Report = withReport(BasePassRequestByTagsOverview, 'preview');

export const PassPreviewRequestByTagsOverviewPage = (): JSX.Element => {
  return (
    <Page
      content={<Report />}
      title={
        <FormattedMessage
          id='PassPreviewRequestByTagsOverviewPage.title'
          defaultMessage='Preview pass by tags'
        />
      }
    />
  );
};
